<template>
	<div class="page">
		<!-- your page -->
        <div class="imgList">
            <div class="imgBox" @mousemove="moveImg" @mouseleave="hideImg">
                <img :src="bigSrc" alt="" class="" >
				<div class="shade" :style="'left:'+left+'px;top:'+top+'px'" v-show="shadeShow"></div>
				<div class="timer" v-show="timerShow">
					<div class="percent">
						<div class="percentBox">
							<div class="percentIn"></div>
						</div>
						<div class="percentWord">
							已售:100.00%
						</div>
					</div>
					<div class="end">
						距离结束:{{timer}}
					</div>
				</div>
            </div>
            <div class="imgNav">
				<div class="prev" @click="prev" v-show="imgList.length>4"><img src="../assets/index/prev.png" alt=""></div>
				<div class="imgItem" v-for="item in imgList" :id="item.select" :style="'left:'+item.left+'px'" @click="clickTab"><img :src="item.src" alt="" :data-id="item.id"></div>
				<div class="next" @click="next" v-show="imgList.length>4"><img src="../assets/index/next.png" alt=""></div>
            </div>
			<div class="enlargement"  v-show="shadeShow">
				<div class="enlargementIn">
					<img :src="bigSrc" alt="" :style="'left:'+bigLeft+'px;top:'+bigTop+'px'">
				</div>
			</div>
        </div>
	</div>
</template>

<script>
	// your script
	// import $ from 'jquery'
	export default {
		name: 'imgList',
		props:["tid","album"],
		data(){
			return {
				bigSrc:'',
				timerShow:false,
				imgList:[],
				left:0,
				top:0,
				bigLeft:0,
				bigTop:0,
				shadeShow:false,
				interVal:'',
				timer:''
			}
		},
		methods:{
			//上一个
			prev(){
				var ev = "prev"
				this.clickChange(ev)
			},
			//下一个
			next(){
				var ev = "next"
				this.clickChange(ev)
			},
			//上下切换
			clickChange(ev){
				clearInterval(this.interVal)
				var imgList = this.imgList
				var index
				for (var i = 0; i < imgList.length; i++) {
					var select = imgList[i].select
					if(select=="choose"){
						index = i
					}
				}
				if(ev=="next"){
					if(index+1 < imgList.length){
						imgList[index].select=""
						imgList[index+1].select = "choose"
						this.bigSrc = imgList[index+1].src
						this.secondCompute(ev)
					}
				}else if(ev=="prev"){
					if(index-1>=0){
						imgList[index].select=""
						imgList[index-1].select = "choose"
						this.bigSrc = imgList[index-1].src
						this.secondCompute(ev)
					}
				}
				this.imgList = imgList
			},
			//点击切换
			clickTab(e){
				var id = e.target.dataset.id
				var that = this
				clearInterval(that.interVal)
				var imgList = that.imgList
				for (var i = 0; i < imgList.length; i++) {
					var iid = imgList[i].id
					imgList[i].select = ""
					if(id==iid){
						that.bigSrc = imgList[i].src
						imgList[i].select = "choose"
					}
				}
				that.imgList = imgList
			},
			//再计算
			secondCompute(ev){
				var imgList = this.imgList
				for (var i = 0; i < imgList.length; i++) {
					var select = imgList[i].select
					if(select=="choose"){
						var index = i
						if(index>3){
							var deviation = index - 3
							for (var k = 0; k < imgList.length; k++) {
								var now = imgList[k].left
								var newD
								if(ev=="next"){
									newD = now-98.5
								}else{
									newD = now+98.5
								}
								imgList[k].left = newD
							}
							this.imgList = imgList
						}else{
							var imgList = this.imgList
							for (var k = 0; k < imgList.length; k++) {
								imgList[k].left = 98.5*k+3.5
							}
							this.imgList = imgList
						}
					}
				}
			},
			//自动轮播
			autoPlay(){
				var imgList = this.imgList
				var autoplay = this.autoplay
				var that = this
				that.interVal = setInterval(function(){
					for (var i = 0; i < imgList.length; i++) {
						var select = imgList[i].select
						imgList[i].select = ""
						if(select=="choose"){
							if(i+1 == imgList.length){
								imgList[0].select = "choose"
								that.bigSrc = imgList[0].src
								break;
							}else{
								imgList[i+1].select = "choose"
								that.bigSrc = imgList[i+1].src
								break;
							}
						}
					}
					that.imgList = imgList
					var ev = "next"
					that.secondCompute(ev)
				},3000)
			},
			//计算左定位
			compute(){
				var imgList = this.imgList
				for (var i = 0; i < imgList.length; i++) {
					imgList[i].left = 98.5*i+3.5
					if(i==0){
						this.bigSrc = imgList[i].src
					}
				}
				this.imgList = imgList
				this.autoPlay()
			},
			//隐藏放大
			hideImg(){
				this.shadeShow = false
			},
			//显示放大
			moveImg(e){
				var shade = document.getElementsByClassName('shade')
				shade[0].addEventListener('mousemove',function(ev){
					ev.stopPropagation()
				})
				var timer = document.getElementsByClassName('timer')
				timer[0].addEventListener('mousemove',function(ev){
					ev.stopPropagation()
				})
				this.shadeShow = true
				var offsetX = e.offsetX,offsetY = e.offsetY
				var left,top
				if(offsetX<50){
					left = 0
				}else if(offsetX>350){
					left = 300
				}else{
					left = offsetX-50
				}
				if(offsetY<50){
					top = 0
				}else if(offsetY>325){
					top = 275
				}else{
					top = offsetY-50
				}
				this.left = left
				this.top = top
				this.bigLeft = -(left*4)
				this.bigTop = -(top*4)
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			var tid = this.$props.tid
			var album = this.$props.album
			var arr = new Array()
			for (var i = 0; i < album.length; i++) {
				var a = album[i]
				var obj
				if(i==0){
					obj = {
						"select":"choose",
						"id":i,
						"src":a,
						"left":3.5
					}
				}else{
					obj = {
						"select":"",
						"id":i,
						"src":a,
						"left":3.5
					}
				}
				arr.push(obj)
			}
			this.imgList = arr
			if(tid==3||tid==4){
				this.timerShow = true
			}
			this.compute()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.imgList{
		width: 400px;
		height: 500px;
		position: relative;
	}
	.imgBox{
		width: 100%;
		height: 375px;
		/* border: 1px solid #B3B3B3; */
		box-sizing: border-box;
		overflow: hidden;
		position: relative;
	}
	.reference{
		width: 100%;
		height: 100%;
	}
	.imgBox img{
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0px;
		top: 0px;
		display: block;
		z-index: 8;
	}
	.imgBox .timer{
		width:100%;
		height: 40px;
		position: absolute;
		bottom: 0px;
		left: 0px;
		z-index: 9;
		background: rgba(255, 0, 0, 0.6);
		line-height: 40px;
		color: yellow;
	}
	.timer .percent,.timer .end{
		width: 60%;
		height: 100%;
		float: left;
	}
	.timer .end{
		width: 40%;
	}
	.percent .percentBox{
		width: 120px;
		height: 14px;
		float: left;
		border: 1px solid yellow;
		border-radius: 7px;
		margin-top: 13px;
		margin-left: 10px;
		box-sizing: border-box;
	}
	.percent .percentIn{
		width: 60%;
		height: 100%;
		border-radius: 6px;
		background: yellow;
	}
	.percent .percentWord{
		width: 100px;
		height: 100%;
		float: left;
		padding-left: 5px;
		box-sizing: border-box;
	}
	.imgNav{
		width: 100%;
		height: 105px;
		margin-top: 20px;
		/* border:1px solid #B3B3B3; */
		box-sizing: border-box;
		overflow: hidden;
		position: relative;
	}
	.imgNav .imgItem{
		width: 95px;
		height: 95px;
		border: 1px solid #B3B3B3;
		box-sizing: border-box;
		position: absolute;
		/* margin-left: 3.5px;
		margin-top: 4px; */
		top:4px;
		overflow: hidden;
	}
	.imgNav #choose{
		border: 2px solid #036DEE;
	}
	.imgItem img{
		width: 100%;
		display: block;
	}
	.shade{
		width: 100px;
		height: 100px;
		position: absolute;
		z-index: 9;
		background: rgba(3,109,238,0.3);
	}
	.enlargement{
		width: 100%;
		height: 375px;
		position: absolute;
		left: 400px;
		top: 0px;
		border: 1px solid #B3B3B3;
		box-sizing: border-box;
		z-index: 10;
		overflow: hidden;
	}
	.enlargementIn{
		width: 100%;
		height: 100%;
		position: relative;
		background: #FFFFFF;
	}
	.enlargement img{
		width: 400%;
		height: 400%;
		display: block;
		position: absolute;
	}
	.prev,.next{
		width: 20px;
		height: 100%;
		position: absolute;
		z-index: 99;
		opacity:0.4;
	}
	.prev{
		left: 0px;
		background: -webkit-linear-gradient(left,#000000, #FFFFFF); 
		background: -o-linear-gradient(right,#000000, #FFFFFF); 
		background: -moz-linear-gradient(right,#000000, #FFFFFF); 
		background: linear-gradient(to right,#000000, #FFFFFF); 
	}
	.next{
		right: 0px;
		background: -webkit-linear-gradient(left,#ffffff, #000000); 
		background: -o-linear-gradient(right,#ffffff, #000000); 
		background: -moz-linear-gradient(right,#ffffff, #000000); 
		background: linear-gradient(to right,#ffffff, #000000); 
	}
	.prev img,.next img{
		width: 16px;
		height: 21px;
		margin-top: 37px;
	}
</style>